export default __webpack_public_path__ + "static/media/cx-bot-blue-filled.b5752c3b.svg";